import React from "react";
import styled, { keyframes } from "styled-components";
import Img from "gatsby-image";
import Link from "gatsby-link";

import ArrowLeft from "../../../../static/icons/arrow-left.svg"
import ArrowRight from "../../../../static/icons/arrow-right.svg"

const Wrapper = styled.ul`
  border-top: 2px dotted ${props => props.theme.post.colors.authorBorder};
  margin: 3em 0 0;
  padding: 2em 0 0;
  list-style: none;
  display: flex;
  justify-content: space-between;

  > * {
    flex: 1;
    max-width: 10rem;
  }

  a {
    text-decoration: none;
    border: 0 !important;
    position: relative;
  }

  .left a {
    align-items: flex-start;
    text-align: left;
    > img {
      position: absolute;
      left: -7.5rem;
      top: 2.5rem;
      height: 5rem;
      width: 5rem;
      z-index: 2;
      @media screen and (max-width: 1100px) {
        top: 0;
        left: 0;
        height: 10rem;
        width: 7.5rem;
        padding-right: 2.5rem;
        padding-left: 1rem;
        background: linear-gradient(90deg, rgba(0,0,0,.5), rgba(0,0,0,0));
      }
    }
  }
  .right a {
    align-items: flex-end;
    text-align: right;
    > img {
      position: absolute;
      right: -7.5rem;
      top: 2.5rem;
      height: 5rem;
      width: 5rem;
      z-index: 2;
      @media screen and (max-width: 1100px) {
        top: 0;
        right: 0;
        height: 10rem;
        width: 7.5rem;
        padding-left: 2.5rem;
        padding-right: 1rem;
        background: linear-gradient(-90deg, rgba(0,0,0,.5), rgba(0,0,0,0));
      }
    }
  }

  .left {
    margin-right: auto;
  }

  .right {
    margin-left: auto;
    .gatsby-image-outer-wrapper {
      display: flex;
      justify-content: flex-end;
    }
    p {
      margin-left: auto;
    }
  }
`;

const Article = styled.li`
  a {
    display: flex;
    flex-direction: column;
  }
`;

const Picture = styled.div`
  @media screen and (max-width: 784px) {
    max-height: 20rem;
    overflow: hidden;
    border-radius: .5rem;
  }
  img {
    box-shadow: ${props => (!props.isAside ? "0 2px 1px rgba(0,0,0,.2)" : "")};
    overflow: hidden;
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    border-radius: .5rem;
  }
  .gatsby-image-outer-wrapper {
    height: 100%;
  }
  .gatsby-image-wrapper {
    height: 10rem;
    width: 10rem;
  }
`;

const Date = styled.p`
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: 0;
  line-height: 1.1;
  text-align: center;
  background: ${props => (props.theme.navigator.backgrounds.wrapper)};
  color: #ffffff;
  text-shadow: none;
  padding: .5rem .75rem;
  border-radius: .5rem;
  max-width: 10rem;
  margin: 1rem 0;
`;

class Navigator extends React.Component {
  render() {
    return (
      <Wrapper>
        {this.props.next && (<Article className="left">
          <Link
            to={this.props.next.node.frontmatter.path}
            onClick={this.props.linkOnClick}
          >
            <img src={ArrowLeft} />
            <Picture>
              <Img
                sizes={this.props.next.node.frontmatter.cover.children[0].sizes}
              />
            </Picture>
            <Date>{ this.props.next.node.frontmatter.date }</Date>
            <p>{ this.props.next.node.frontmatter.title }</p>
          </Link>
        </Article>)}
        {this.props.prev && (<Article className="right">
          <Link
            to={this.props.prev.node.frontmatter.path}
            onClick={this.props.linkOnClick}
          >
            <img src={ArrowRight} />
            <Picture>
              <Img
                sizes={this.props.prev.node.frontmatter.cover.children[0].sizes}
              />
            </Picture>
            <Date>{ this.props.prev.node.frontmatter.date }</Date>
            <p>{ this.props.prev.node.frontmatter.title }</p>
          </Link>
        </Article>)}
      </Wrapper>
    )
  }
}

export default Navigator;




// WEBPACK FOOTER //
// ./src/components/Article/Navigator/Navigator.jsx